export default {
  id: "page17",
  show: "parseInt(values.respondent_dzieci)>0",

  questions: [
    {
      label:
        "Czy wyraża Pan(i) zgodę na to, aby w przyszłości zapraszać Pana(i) dziecko (niepełnoletnie, poniżej 18 roku życia) na degustowanie i ocenę naszych produktów? Oczywiście każdorazowo przed takim badaniem będzie Pan(i) dodatkowo pytany(a) o zgodę.",
      number: "29",
      type: "radio",
      id: "ankieta_zgodaDzieci",
      required: true,
      columns: true,
      labelWidth: "is-three-fifths",
      options: [{ value: "1", name: "Tak" }, { value: "0", name: "Nie" }]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/page17.js